import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  title: {
    defaultValue: 'Transferir Dashboard',
    key: 'transfer-dashboard-title',
  },
  subtitle: {
    defaultValue: 'OBS: Não é possivel transferir componentes relacionados a aba de overview de marca.',
    key: 'transfer-dashboard-subtitle',
  },
  inputTitle: {
    defaultValue: 'Nome do Workspace de destino',
    key: 'transfer-dashboard-inputTitle',
  },
  buttonTransfer: {
    defaultValue: 'Transferir',
    key: 'transfer-dashboard-buttonTransfer',
  },
  successfullyTransferredDashboard: {
    defaultValue: 'Seu dashboard está sendo transferido e estará disponível em breve no workspace de destino.',
    key: 'transfer-dashboard-successfully',
  },
  dashboardNotFound: {
    defaultValue: 'Dashboard não encontrado.',
    key: 'transfer-dashboard-not-found',
  },
  reportJobCantBeDuplicated: {
    defaultValue: 'Este relatório não pode ser duplicado pois é um dashboard report.',
    key: 'transfer-dashboard-cant-duplicate',
  },
  unAuthorizedTransferDashboard: {
    defaultValue: 'Você não tem permissão para transferir este dashboard.',
    key: 'transfer-dashboard-unauthorized',
  },
})
